module.exports = __webpack_public_path__ + "static/img/icon_4_mk.d94152f6.svg";